/* global Swiper */
document.addEventListener('DOMContentLoaded', () => {
	// Render cross sell popup
	new Swiper('.cross-sell-popup-swiper.swiper', {
		slidesPerView: 1,
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			767: {
				slidesPerView: 3,
			},
		},
	});

	initCollectionRelatedColorPicker();
});

/* exported toggleCrossSellPopup */
function toggleCrossSellPopup(isPopupActive) {
	/* global CROSS_SELL_COOKIE_KEY, CROSS_SELL_COOKIE_DAYS_TO_EXPIRE, setCookie, getCookie, addVariantToCart, CROSS_SELL_ADD_TO_CART_SUCCESS_MESSAGE, CROSS_SELL_ADD_TO_CART_FAIL_MESSAGE */
	/* exported addCrossSellProductToCart */

	const goToCheckoutBtn = document.getElementById('update-cart');
	const crossSellPopup = document.getElementById('cross-sell-popup');

	if (!isPopupActive) {
		setCookie(CROSS_SELL_COOKIE_KEY, true, CROSS_SELL_COOKIE_DAYS_TO_EXPIRE);
		crossSellPopup.classList.remove('active');
		goToCheckoutBtn.click();
		return;
	}

	if (getCookie(CROSS_SELL_COOKIE_KEY)) {
		crossSellPopup.classList.remove('active');
		goToCheckoutBtn.click();
		return;
	}
	crossSellPopup.classList.add('active');
}

function addCrossSellProductToCart(btn) {
	const selectInput = document.getElementById(`${btn.dataset.selectId}`);
	// Can select one variant at a time
	// eslint-disable-next-line no-magic-numbers
	const selectedVariant = selectInput?.selectedOptions[0];
	const selectedVariantId = selectedVariant.dataset.variantId;

	// eslint-disable-next-line no-magic-numbers
	addVariantToCart(selectedVariantId, 1, false).then((response) => {
		const imageWrapper = document.getElementById(`${btn.dataset.imageId}`);
		const previousMessage = imageWrapper?.querySelector('span');
		const messageText = document.createElement('span');
		messageText.classList.add('cross-sell-popup-message');
		if (response?.success) {
			messageText.innerHTML = CROSS_SELL_ADD_TO_CART_SUCCESS_MESSAGE;
		} else {
			messageText.innerHTML = CROSS_SELL_ADD_TO_CART_FAIL_MESSAGE;
		}
		if (previousMessage) {
			previousMessage.remove();
		}
		imageWrapper?.appendChild(messageText);
		// eslint-disable-next-line no-magic-numbers
		setTimeout(() => messageText.remove(), 3000);
	});
}

// Cross sell popup related colors
function initCollectionRelatedColorPicker() {
	const relatedColors = document.querySelectorAll('.cross-sell-related-color:not(.related-color-loaded');
	if (relatedColors.length) {
		[...relatedColors].forEach((color) => {
			// Return if single colored product
			if (!color.nextElementSibling && !color.previousElementSibling) {
				return;
			}
			color.addEventListener('click', () => changeToRelatedProduct(color));
			color.classList.add('related-color-loaded');
		});
	}
}

// Related color product change
// eslint-disable-next-line no-unused-vars
async function changeToRelatedProduct(color) {
	// If same color click again, do nothing
	const colorPickerWrapper = color.closest('.cross-sell-related-colors-picker');
	const productPreviousColor = colorPickerWrapper.querySelector(
		'.cross-sell-related-color-selected'
	);
	if (color.isEqualNode(productPreviousColor)) {
		return;
	}
	const productBlock = document.querySelector(
		`.cross-sell-popup-slide[data-product-id="${color.dataset.originalProductId}"]`
	);

	// Loading state
	const slideImageWrapper = productBlock?.querySelector('.cross-sell-popup-image-wrapper');
	const slideImage = productBlock?.querySelector('.cross-sell-popup-image-wrapper img');
	slideImageWrapper?.classList.add('related-color-loading-images');
	
	// Collect data
	const relatedColorRawData = await fetch(`/products/${color.dataset.productHandle}.json`);
	const relatedColorData = await relatedColorRawData.json();
	const productLink = productBlock?.querySelector('.cross-sell-popup-slide-title a');
	const relatedColorImageUrl = relatedColorData.product.image.src;
	const newProductUrl = `${window.location.origin}/products/${relatedColorData.product.handle}`;
	const productVariantsSelect = productBlock?.querySelector('.cross-sell-popup-slide-size-picker');
	
	// Change product settings
	productLink.href = newProductUrl;
	slideImage.src = relatedColorImageUrl;

	updateVariantsSelectOptions(productVariantsSelect, relatedColorData);
	setProductPrices(productBlock, relatedColorData);
	handleProductLabelTags(relatedColorData, productBlock, slideImageWrapper);

	// Change selected color
	productPreviousColor?.classList.remove('cross-sell-related-color-selected');
	color.classList.add('cross-sell-related-color-selected');

	// Remove loading state
	slideImageWrapper?.classList.remove('related-color-loading-images');
}

function handleProductLabelTags(relatedColorData, productBlock, slideImageWrapper) {
	const productTags = relatedColorData.product.tags.split(',').map((tag) => tag.trim());
	const productTagLabel = '_labelText';
	const productLabelDiv = productBlock.querySelector('.cross-sell-popup-label');

	let hasMatchingLabel = false;

	for (let i = 0; i < productTags.length; i++) {
		const tag = productTags[i];

		if (tag.includes(productTagLabel)) {
			const labelText = tag.split('_').pop();
			hasMatchingLabel = true;

			handleproductLabelDiv(productLabelDiv, slideImageWrapper, labelText);
		}
	}

	handleRemoveLabelDiv(hasMatchingLabel, productLabelDiv);
}

function handleproductLabelDiv(productLabelDiv, slideImageWrapper, labelText) {
	if (!productLabelDiv) {
		const newLabelDiv = document.createElement('div');
		newLabelDiv.classList.add('cross-sell-popup-label');
		newLabelDiv.innerText = labelText;
		slideImageWrapper.appendChild(newLabelDiv);
	} else {
		productLabelDiv.innerText = labelText;
	}
}

function handleRemoveLabelDiv(hasMatchingLabel, productLabelDiv) {
	if (!hasMatchingLabel && productLabelDiv) {
		productLabelDiv.remove();
	}
}

function updateVariantsSelectOptions(productVariantsSelect, relatedColorData) {
	// Update variants select options
	
	const newVariantsSelectOptions = relatedColorData.product.variants.map((variant) => {
		const option = document.createElement('option');
		option.value = variant.id;
		option.dataset.variantId = variant.id;
		option.innerHTML = variant.title;
		return option;
	});
	
	productVariantsSelect.innerHTML = '';
	newVariantsSelectOptions.forEach((option) => {
		productVariantsSelect.appendChild(option);
	});
}

function setProductPrices(productBlock, relatedColorData) {
	// Set prices to cheapest product variant (Theme behavior at collection page)
	// eslint-disable-next-line no-magic-numbers
	const firstVariant = relatedColorData.product.variants.sort((a, b) => a.price - b.price)[0];

	const productPrice = productBlock.querySelector('.cross-sell-popup-slide-price');
	if (productPrice) {
		productPrice.innerText = `${firstVariant.price} €`;
	}
	
	const productComparePrice = productBlock.querySelector('.cross-sell-popup-slide-compare-price');

	if (productComparePrice) {
		productComparePrice.innerText = `${firstVariant.compare_at_price} €`;
	}
}